import './SignUp.scss'
import { useHistory } from 'react-router-dom'
import { Form, Input, Button, Modal, Layout, Select, Checkbox, message } from 'antd'
import { useAppDispatch } from '../../../app/hooks'

import { signupAsync } from '../../../reducers/users/usersSlice';
import config from '../../../config/config'

import ReCAPTCHA from "react-google-recaptcha";
import md5 from 'js-md5'
import mobileCountryCodes from '../../../config/mobileCountryCodes'
import logo from '../../../assets/logo2.png'
import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '../../../utils/query';

const { Sider, Content } = Layout
const { Option } = Select
const siteKey = '6LcxbsIdAAAAAAzKDEM6QpIVAC1RzCUY9ahYeqoo'
const SignUp = () => {
  const dispatch = useAppDispatch();
  const recaptchaRef = useRef<any>()
  const history = useHistory()
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false)
  const query: any = useQuery()
  const [mobileCountryCode, setMobileCountryCode] = useState(query.mcc || '81')
  const [sunsetModalVisible] = useState(true)
  const selectBefore = (
    <Select value={mobileCountryCode} onChange={(value: string) => setMobileCountryCode(value)} className="select-before">
      {
        mobileCountryCodes.map((code: any) =>
          <Option key={code.code} value={code.code}>{code.code}</Option>)
      }
    </Select>
  );
  const onFinish = async (values: any) => {
    const recaptchaValue = recaptchaRef.current?.getValue()
    values.password = md5(values.password)
    values.companyId = query.id
    if (!values.agree) {
      return message.error(t('work.PolicyText'))
    }
    values.mobileCountryCode = mobileCountryCode
    values['g-recaptcha-response'] = recaptchaValue
    setLoading(true)
    const result = await dispatch(signupAsync({
      ...values
    }))
    setLoading(false)
    const { payload } = result
    if (payload) {
      const { data, code, msg } = payload
      if (code === 0) {
        const state = {
          email: values.email,
          fullName: values.fullName,
          phone: values.phone,
          id: data.id
        }

        history.push({
          pathname: '/signup/result',
          state
        }
        )
      } else if (msg) {
        if (code === 4010005) {
          Modal.error({
            title: 'The link is invalid, please contact the administrator'
          })
        } else {
          Modal.error({
            title: 'Error',
            content: msg,
          });
        }
      }
    }
    if (typeof payload === 'string') {
      Modal.error({
        title: 'Error',
        content: payload
      })
    }
  }
  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo)
  }

  return (
    <Layout className='sign-layout'>
      <Modal
        open={sunsetModalVisible}
        closable={false}
        footer={null}
        maskClosable={false}
        centered
        width={520}
      >
        <div style={{ padding: '24px 0' }}>
          <div style={{ textAlign: 'center' }}>
            <img src={logo} alt="Eyerising International" style={{ height: 48, marginBottom: 24 }} />
          </div>
          <h3 style={{ marginBottom: 12 }}>【旧ポータルサイト停止のお知らせ】</h3>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: '#555' }}>
            現在、新ポータルサイトの開設に伴い、旧ポータルサイト(こちらのQRコード)はご利用いただけません。
          </p>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: '#555' }}>
            新ポータルサイトへの登録・ログインにつきましては、下記サポート窓口までお問い合わせください。<br />
            <a href="mailto:eyerising-jp@eyelens.sg">eyerising-jp@eyelens.sg</a>
          </p>
          <h3 style={{ marginBottom: 12, marginTop: 24 }}>【機器アップデート方法】</h3>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: '#555' }}>
            機器をバージョン5.1.0へアップデートし、新ポータルサイトへ接続するためには、以下の手順をお試しください。
          </p>
          <ol style={{ fontSize: 15, lineHeight: 1.7, color: '#555', paddingLeft: 20, margin: 0 }}>
            <li>機器の電源をオンにする</li>
            <li>Wi-Fiへ接続する</li>
            <li>アップデート中は、画面上に緑色の矢印が表示されます (矢印が表示されずともソフトウェアバージョンのアップデートが完了する場合がございます。)</li>
            <li>約15分後、機器の電源をオフにし、再度オンにする</li>
            <li>設定画面に新しいバージョンが表示されます</li>
          </ol>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: '#555', marginTop: 16 }}>
            上記の方法でアップデートが完了しない場合、下記の方法をお試しください。
          </p>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: '#555' }}>
            方法①:上記のアップデート方法を複数回お試しいただく。
          </p>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: '#555' }}>
            方法②:異なるWi-Fi(テザリングを含む)に接続し、ソフトウェアバージョンのアップデートが行われるか確認を行う(アップデート方法と作業は同じですが、異なるWi-Fiに接続してください。)
          </p>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: '#555' }}>
            何卒よろしくお願いいたします。
          </p>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: '#555' }}>
            新ポータルサイト：<br />
            <a href="https://dashboard.eyerising.international" target="_blank" rel="noopener noreferrer">
              https://dashboard.eyerising.international
            </a>
          </p>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: '#555' }}>
            Eyerising International
          </p>
        </div>
      </Modal>
      <Sider className='sign-sider' width={"40%"}>
        <div className="AuthLeftBlock_blue__g24c9">
          <div>
            <h2 className="AuthLeftBlock_h2__38SEX">{t('signup.Title')}</h2>
          </div>
        </div>
      </Sider>
      <Content className='sign-content'>
        <Form
          className="sign-form"
          name="basic"
          labelCol={{ span: 7 }}
          wrapperCol={{ span: 14 }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <div className="mobile-location">
            <div>
              <h2 className="AuthLeftBlock_h2__38SEX">{t('signup.Title')}</h2>
            </div>
          </div>
          <Form.Item name="firstName"
            className="sign-input" label={t('signup.firstName')} rules={[{ required: true, message: t('work.FirstNameRequiredText') },
            ]}>
            <Input placeholder="" />
          </Form.Item>
          <Form.Item name="middleName"
            className="sign-input" label={t('signup.middleName')}>
            <Input placeholder="" />
          </Form.Item>
          <Form.Item name="lastName"
            className="sign-input" label={t('signup.lastName')} rules={[{ required: true, message: t('work.LastNameRequiredText') }]}>
            <Input placeholder="" />
          </Form.Item>
          <Form.Item
            className="sign-input"
            label={t('signup.email')}
            name="email"
            rules={[{ required: true, message: t('signup.Please_input_your_email') }, {
              type: 'email', message: t('work.EmailType')
            }]}
          >
            <Input maxLength={100} />
          </Form.Item>
          <Form.Item
            className="sign-input"
            label={t('signup.Confirm_email')}
            name="confirmEmail"
            rules={[{ required: true, message: t('signup.Please_input_your_email') }, {
              type: 'email', message: t('work.EmailType')
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('email') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(`${t('signup.twoEmailTsext')}`));
              },
            }),]}
          >
            <Input maxLength={100} />
          </Form.Item>
          <Form.Item
            className="sign-input"
            label={t('signup.Phone')}
            rules={[{ required: true, message: t('signup.Please_input_your_phone') },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (value && value.length >= 8) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(t('work.phoneLengthText')));
              },
            }),
            ({ getFieldValue }) => ({
              validator(_, value) {
                var reg = new RegExp(/^\d+$/);
                if (reg.test(value)) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(t('work.phoneNumberText')));
              },
            })]}
            name="phone"
          >
            <Input placeholder="" addonBefore={selectBefore} />
          </Form.Item>
          <Form.Item
            className="sign-input"
            label={t('signup.password')}
            name="password"
            rules={[{ required: true, message: t('signup.Please_input_your_password') },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (value && value.length >= 8) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(t('work.passwordlengthText')));
              },
            }),
            ({ getFieldValue }) => ({
              validator(_, value) {
                var reg = new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)/);
                if (reg.test(value)) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(t('work.passwordText')));
              },
            })]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label={t('signup.Confirm_password')}
            className="sign-input"
            name="confirmPassword"
            rules={[
              {
                required: true,
                message: t('signup.Please_input_your_password')

              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(`${t('signup.twoPasswordText')}`));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label=''
            name="agree"
            valuePropName="checked"
            rules={[{ required: true, message: t('work.PolicyText') }]}
          >
            <Checkbox>
              {t('work.Readandagree')}  <a href={`${config.domain}/static/${i18n.language.slice(0, 2)}/PrivacyPolicy.pdf`} target="view_window">
                {t('work.PrivacyPolicy')}
              </a></Checkbox>
          </Form.Item>
          {
            process.env.NODE_ENV === 'production' && !loading ? (
              <Form.Item
                className="sign-input sign-captch"
                label="Captcha"
                // name="captcha"
                rules={[{ required: true, message: t('sign.Please_input_captcha') }]}
              >
                <ReCAPTCHA
                  sitekey={siteKey}
                  ref={recaptchaRef}
                />
              </Form.Item>) : ''
          }
          <Form.Item
            className='sign-submit'
            label="submit">
            <Button block loading={loading} type="primary" htmlType="submit">
              {t('signup.done')}
            </Button>
          </Form.Item>
        </Form></Content>
    </Layout>

  )
}

export default SignUp;
